import Vue from 'vue'
import Router from 'vue-router'
import MainLayout from '../views/layout/MainLayout.vue'
import LoginLayout from '../views/layout/LoginLayout.vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

Vue.use(Router)

NProgress.inc(0.2)
NProgress.configure({
  easing: 'ease',
  speed: 500,
  showSpinner: false
})

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/',
    name: '',
    component: MainLayout,
    children: [
      {
        path: '/login',
        name: 'Login',
        meta: {
          needLogin: false,
          title: '登录'
        },
        component: () => import('../views/login/login.vue')
      },
      {
        path: '/register',
        name: 'Register',
        meta: {
          needLogin: false,
          title: '注册'
        },
        component: () => import('../views/register/register.vue')
      },
      {
        path: '/search',
        name: 'Search',
        meta: {
          needLogin: false,
          title: '订单查询'
        },
        component: () => import('../views/service/search.vue')
      },
      // {
      //   path: '/trial',
      //   name: 'Trial',
      //   meta: {
      //     needLogin: false,
      //     title: '运费试算'
      //   },
      //   component: () => import('../views/service/trial.vue')
      // },
      {
        path: '/productInfo',
        name: 'ProductInfo',
        meta: {
          needLogin: false,
          title: '产品简介'
        },
        component: () => import('../views/product/detail.vue')
      },
      {
        path: '/about',
        name: 'About',
        meta: {
          needLogin: false,
          title: '关于我们'
        },
        component: () => import('../views/about/index.vue')
      }
    ]
  },
  {
    path: '/',
    name: '',
    component: LoginLayout,
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        meta: {
          needLogin: true,
          title: '首页',
          permission: 'dashboard:view' // TODO
        },
        component: () => import('../views/dashboard/dashboard.vue')
      },
      {
        path: '/sheetDetail',
        name: 'SheetDetail',
        meta: {
          needLogin: true,
          title: '异常详情',
          permission: 'order:view' // TODO
        },
        component: () => import('../views/worksheet/detail.vue')
      },
      {
        path: '/order',
        name: 'Order',
        meta: {
          needLogin: true,
          title: '订单',
          permission: 'order:view'
        },
        component: () => import('../views/order/order.vue')
      },
      {
        path: '/orderDetail',
        name: 'OrderDetail',
        meta: {
          needLogin: true,
          title: '订单详情',
          permission: 'order:view'
        },
        component: () => import('../views/order/orderDetail.vue')
      },
      {
        path: '/trust',
        name: 'Trust',
        meta: {
          needLogin: true,
          title: '客户托单',
          permission: 'trust:view'
        },
        component: () => import('../views/trust/list.vue')
      },
      {
        path: '/trustCreate',
        name: 'TrustCreate',
        meta: {
          needLogin: true,
          title: '创建托单',
          permission: 'trust:view'
        },
        component: () => import('../views/trust/create.vue')
      },
      {
        path: '/trustDetail',
        name: 'TrustDetail',
        meta: {
          needLogin: true,
          title: '托单详情',
          permission: 'trust:view'
        },
        component: () => import('../views/trust/detail.vue')
      },
      {
        path: '/label',
        name: 'Label',
        meta: {
          needLogin: true,
          title: '合规',
          permission: 'label:view'
        },
        component: () => import('../views/label/list.vue')
      },
      {
        path: '/customs',
        name: 'Customs',
        meta: {
          needLogin: true,
          title: '关务',
          permission: 'customs:view'
        },
        component: () => import('../views/customs/customs.vue')
      },
      {
        path: '/coa',
        name: 'Customs2',
        meta: {
          needLogin: true,
          title: '美国清关',
          permission: 'customs2:view'
        },
        component: () => import('../views/customs/customs2.vue')
      },
      {
        path: '/hts',
        name: 'HTS&Description',
        meta: {
          needLogin: true,
          title: 'HTS&Description',
          permission: 'hts:view'
        },
        component: () => import('../views/customs/sku.vue')
      },
      {
        path: '/tariff',
        name: 'Tariff',
        meta: {
          needLogin: true,
          title: 'Tariff',
          permission: 'tariff:view'
        },
        component: () => import('../views/customs/tariff.vue')
      },
      {
        path: '/mid',
        name: 'Mid',
        meta: {
          needLogin: true,
          title: 'Mid',
          permission: 'customs2:view'
        },
        component: () => import('../views/customs/mid.vue')
      },
      {
        path: '/bill',
        name: 'Bill',
        meta: {
          needLogin: true,
          title: '账单',
          permission: 'bill:view'
        },
        component: () => import('../views/bill/bill.vue')
      },
      {
        path: '/billDetail',
        name: 'BillDetail',
        meta: {
          needLogin: true,
          title: '账单详情',
          permission: 'bill:view'
        },
        component: () => import('../views/bill/billDetail.vue')
      },
      {
        path: '/my',
        name: 'My',
        meta: {
          needLogin: true,
          title: '我的',
          permission: 'mine:view'
        },
        component: () => import('../views/my/my.vue')
      },
      {
        path: '/createOrder',
        name: 'CreateOrder',
        meta: {
          needLogin: true,
          title: '下单',
          permission: 'book:add'
        },
        component: () => import('../views/order/createOrder.vue')
      },
      {
        path: '/booking',
        name: 'Booking',
        meta: {
          needLogin: true,
          title: '订舱',
          permission: 'booking:view'
        },
        component: () => import('../views/booking/booking.vue')
      },
      {
        path: '/book',
        name: 'Bookings',
        meta: {
          needLogin: true,
          title: '订舱',
          permission: 'booking:view'
        },
        component: () => import('../views/booking/createMawb.vue')
      },
      {
        path: '/mawb',
        name: 'Mawb',
        meta: {
          needLogin: true,
          title: '主单',
          permission: 'mawb:view'
        },
        component: () => import('../views/mawb/mawb.vue')
      },
      {
        path: '/mawbOpt',
        name: 'Mawb-opt',
        meta: {
          needLogin: true,
          title: '操作主单',
          permission: 'mawb-opt:view'
        },
        component: () => import('../views/vendorOpt/list.vue')
      },
      {
        path: '/mawbDetail',
        name: 'Mawb Detail',
        meta: {
          needLogin: true,
          title: '主单详情',
          permission: 'mawb-opt:view'
        },
        component: () => import('../views/vendorOpt/detail.vue')
      }
    ]
  },

  {
    path: '/home',
    name: 'Home',
    meta: {
      needLogin: false,
      title: '首页'
    },
    component: () => import('../views/home.vue')
  },
  {
    path: '/404',
    name: '404',
    meta: {
      needLogin: false,
      title: '找不到页面'
    },
    component: () => import('../views/404.vue')
  },
  {
    path: '/403',
    name: '403',
    meta: {
      needLogin: false,
      title: '没有权限'
    },
    component: () => import('../views/403.vue')
  },
  {
    path: '/databoard',
    name: 'Databoard',
    meta: {
      needLogin: true,
      title: '看板',
      permission: 'databoard:view'
    },
    component: () => import('../views/databoard/index.vue')
  },
]

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  // mode:"history",
  routes: routes
})

const hasPermission = (code) => {
  // debugger;
  const permissions = localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')).permissions

  return permissions.find(item => item == code)
}

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (to.matched && to.matched.length > 0) {
    let hostName = location.hostname.toLowerCase();

    if (hostName.indexOf('tolead.com') != -1) {
      hostName = "ToLead"
    } else {
      hostName = "Diamond Up"
    }

    document.title = `${to.meta.title} | ${hostName}-OMS`
    if (to.meta.needLogin) {
      if (localStorage.getItem('access_token')) {
        // 已登录，判断权限
        const role = hasPermission(to.meta.permission)
        if (role) {
          next()
        } else {
          next('/403')
        }
      } else {
        // 未登录，打开登录页面
        next('/login')
      }
    } else {
      next()
    }
  } else {
    next('/404')
  }
})

router.afterEach(() => {
  NProgress.done()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js